import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { PassTest, Question } from "types";
import type { RootState } from "../store";

// Define a type for the slice state
type QuestionType = Question;

interface PassTestState {
  passedTests: PassTest[];
  current: PassTest;
}

// Define the initial state using that type
const initialState: PassTestState = {
  passedTests: [],
  current: null,
};

export const passTestSlice = createSlice({
  name: "passTest",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setCurrent: (state, action: PayloadAction<PassTest>) => {
      state.current = action.payload;
    },
    setPassedTests: (state, action: PayloadAction<PassTest[]>) => {
      state.passedTests = action.payload;
    },
  },
});

export const { setCurrent, setPassedTests } = passTestSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectPassTest = (state: RootState) => state.passTest;
export default passTestSlice.reducer;
